import React from 'react'
import {motion} from 'framer-motion'
import './CallToAction.scss'

const CallToAction = ({ 
  title = "Ready to get started?", 
  description = "Let's work together to bring your vision to life.", 
  primaryButton = "Get Started", 
  secondaryButton = "Learn More",
  primaryAction = () => {},
  secondaryAction = () => {},
  backgroundColor = "primary"
}) => {
  return (
    <motion.div
      whileInView={{opacity: [0, 1], y: [50, 0]}}
      transition={{duration: 0.6}}
      className={`app__cta ${backgroundColor === 'primary' ? 'app__cta--primary' : 'app__cta--secondary'}`}
    >
      <div className='app__cta-content'>
        <h3 className='app__cta-title'>{title}</h3>
        <p className='app__cta-description'>{description}</p>
        
        <div className='app__cta-buttons'>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className='app__cta-btn app__cta-btn--primary'
            onClick={primaryAction}
          >
            {primaryButton}
          </motion.button>
          
          {secondaryButton && (
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className='app__cta-btn app__cta-btn--secondary'
              onClick={secondaryAction}
            >
              {secondaryButton}
            </motion.button>
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default CallToAction